export default {
    nav: {
      about: "회사소개",
      services: "서비스",
      momo: "MOMO",
      team: "팀",
      contact: "문의",
      cta: "MOMO 시작하기",
    },
    hero: {
      badge: "AI-Driven Technology Company",
      line1: "AI를 통해",
      highlight: "사람과 사람을",
      line2: "연결하는 기술",
      sub1: "IKOB는 인공지능으로 언어의 벽을 허물고,",
      sub2: "세계가 만나는 새로운 플랫폼을 만듭니다.",
      cta: "아이콥 알아보기",
    },
    about: {
      label: "About IKOB",
      title1: "인간과 기술을",
      title2: "잇는 지능의 중심",
      p1_pre: "아이콥은 ",
      p1_bold: "인공지능 기술로 사람과 사람을 연결하는 서비스",
      p1_suf: "를 만드는 기업입니다.",
      p2_pre: "저희의 AI 코어는 단순한 자동화를 넘어 사람 사이의 신뢰를 설계합니다. 소셜 교류 플랫폼 ",
      p2_suf: "를 중심으로, 라이프스타일 및 적합도 알고리즘을 활용하여 사람과 사람의 안전하고     편안한 만남을 통해 자연스럽게 사람이 연결되는 세상을 구축합니다.",
      p3: "모모 플랫폼은 유저의 감성적 Needs를 충족시키는 서비스들로 확장되어 지친 현대인들의 마음을   나눌 수   있는 가까운 친구로 자리잡고자 합니다.",
      val_i_word: "Inspire",
      val_i_desc: "영감을 만드는 사람. 새로운 가능성을 발견하고 문화적 교류의 가치를 창조합니다.",
      val_k_word: "Know",
      val_k_desc: "지식을 설계하는 사람. 데이터와 AI 기반의 정교한 기술 아키텍처를 구현합니다.",
      val_o_word: "Optimize",
      val_o_desc: "AI Core · 중앙 인텔리전스. 인간과 기술을 연결하는   지능의 핵심입니다.",
      val_b_word: "Build",
      val_b_desc: "제품과 세상을 구축하는 사람. 아이디어를 실제 서비스로 만들어냅니다.",
      stat1_num: "70%",
      stat1_label: "외국인 관광객 중\n현지인 교류 희망",
      stat2_num: "86%",
      stat2_label: "언어 장벽으로\n교류 어려움",
      stat3_num: "100ms",
      stat3_label: "실시간 근거리\n매칭 속도",
      stat4_num: "3단계",
      stat4_label: "다단계 신원인증\n안전 시스템",
    },
    services: {
      label: "Core Technology",
      title: "핵심 기술",
      desc: "IKOB의 AI 기술이 만드는 안전하고 실시간적인 연결 경험",
      tech1_tag: "Location",
      tech1_title: "PostGIS 실시간 탐색 엔진",
      tech1_desc: "위치 기반 데이터베이스 기술로 100ms 이내에 주변 사용자와 모임을 찾아드립니다. 정확한 거리 계산과 빠른 응답 속도를 제공합니다.",
      tech2_tag: "AI · NLP",
      tech2_title: "AI 실시간 통역 에이전트",
      tech2_desc: "GPT-4 기반의 실시간 음성 통역 기술로 언어 장벽 없는 자연스러운 대화를 지원합니다. 한국어, 영어,   일어, 중국어 등 다국어를 지원합니다.",
      tech3_tag: "Safety",
      tech3_title: "AI 안전 에이전트",
      tech3_desc: "실시간 대화 모니터링과 위험 상황 자동 감지로 안전한 교류 환경을 보장합니다. 여권 OCR 기반 3단계  신원인증을 제공합니다.",
      tech4_tag: "Trust Score",
      tech4_title: "행동 기반 신뢰도 평가",
      tech4_desc: "사용자의 실제 행동 패턴을 분석해 신뢰 점수를 산정합니다. 안전하고 신뢰할 수 있는 커뮤니티 환경을  만들어 갑니다.",
    },
    momo: {
      label: "Service Platform",
      title1: "K-컬처 소셜 교류",
      title2: "플랫폼",
      desc: "외국인과 한국인을 실시간으로 연결하는\n새로운 소셜 경험",
      feat1_title: "MOMO NOW",
      feat1_desc: "지도 기반 실시간 로컬 피드. 지금 내 주변의 모임과 사람을 즉시 확인하세요.",
      feat2_title: "즉흥 매칭 시스템",
      feat2_desc: "사전 예약 없이 '지금 이 순간, 이 장소'에서의 만남. Non-Dating 설계로 순수한 문화 교류를 추구합니다.",
      feat3_title: "3단계 안전 인증",
      feat3_desc: "여권 OCR 인식 등 다단계 인증으로 검증된 사용자만 연결됩니다.",
      feat4_title: "로컬 파트너십",
      feat4_desc: "지역 소상공인과 연계해 진짜 한국다운 경험을 제공하고 지역 경제 활성화에 기여합니다.",
      install_cta: "MOMO 설치하기",
    },
    social: {
      label: "Social Impact",
      title: "사회적 가치",
      desc: "IKOB이 만들어가는 더 나은 세상",
      card1_title: "글로벌 문화 교류",
      card1_desc: "언어 장벽을 넘어 외국인과 한국인이 자연스럽게 만나고        \nK-컬처를 진정성 있게 경험할 수 있는 환경을 만듭니다.",
      card2_title: "지역 상생 경제",
      card2_desc: "정보에서 소외된 지역 소상공인과 외국인 관광객을 연결해   \n관광 활성화와 지역 경제 선순환을 이끌어냅니다.",
      card3_title: "안전한 교류 환경",
      card3_desc: "AI 기반 안전 에이전트와 다단계 인증 시스템으로 모든 사용자\n가 신뢰하고 참여할 수 있는 공정한 플랫폼을 구축합니다.",
    },
    team: {
      label: "Our Team",
      title1: "아이콥을 이끄는",
      title2: "사람들",
      desc: "각자의 전문성으로 하나의 비전을 함께 만들어갑니다",
      m1_name: "오준호",
      m1_title: "대표이사 (CEO)",
      m1_subtitle: "Chief Executive Officer",
      m1_edu: "서강대학교 데이터사이언스 AI 공학석사",
      m1_bio: "AI와 데이터사이언스 분야의 전문 지식을 바탕으로 IKOB를 창업했습니다. 인간과 기술의 접점에서 새로운 가치를 창출하는 것을 사명으로 삼고 있으며, MOMO를 통해 전 세계 사람들이 더 쉽고 안전하게 연결될 수 있는 세상을 만들어갑니다.",
      m2_name: "김희준",
      m2_title: "개발총괄 이사 (CTO)",
      m2_subtitle: "Chief Technology Officer",
      m2_edu: "서강대학교 데이터사이언스 AI 공학석사",
      m2_bio: "AI 아키텍처 설계와 풀스택 개발 역량을 바탕으로 MOMO의 기술적 기반을 구축합니다. PostGIS 기반 실시간 위치 탐색 엔진, AI 통역 에이전트, 안전 시스템 개발을\n총괄하며 서비스의 기술 완성도를 책임집니다.",
      m3_name: "임미진",
      m3_title: "마케팅총괄 이사 (CMO)",
      m3_subtitle: "Chief Marketing Officer",
      m3_edu: "중앙대학교 영문학사",
      m3_bio: "브랜드 전략과 디지털 마케팅 전문성을 바탕으로 MOMO의 시장 확장을 이끕니다. K-컬처 트렌드를 활용한 콘텐츠 마케팅과 글로벌 사용자 성장 전략을 총괄하며, IKOB의 브랜드 가치와 메시지를 세상에 전달합니다.",
      m4_name: "방정열",
      m4_title: "법무총괄이사 (CLO)",
      m4_subtitle: "Chief Legal Officer",
      m4_edu: "서울대학교 법학과",
      m4_bio: "현직 중대형 로펌 파트너 변호사로 활동하며 쌓은 법률 전문성으로 IKOB의 법무를 총괄합니다. 개인정보 보호, AI 윤리 법규 준수, 계약·투자 법률 자문 등\n회사의      건전한 성장을 법적으로 뒷받침합니다.",
    },
    contact: {
      label: "Contact Us",
      title1: "아이콥과 함께",
      title2: "새로운 가능성을",
      title3: "열어보세요",
      desc: "투자 문의, 제휴 협력, 서비스 관련 문의를\n언제든지 연락주세요.",
      website_label: "Website",
      email_info_label: "Email",
      phone_label: "전화",
      address_label: "Address",
      momo_label: "MOMO 서비스",
      address_val: "본사: 광주광역시 서구 양동로25번길 2, 2층 244호\nAI연구소: 서울특별시 강남구 강남대로112길 47, 2층 498A호",
      form_title: "문의하기",
      name_label: "이름 / Name *",
      name_placeholder: "성함을 입력해주세요",
      email_label: "이메일 / Email *",
      email_placeholder: "이메일 주소를 입력해주세요",
      type_label: "문의 유형",
      type1: "투자 문의",
      type2: "제휴 협력",
      type3: "서비스 문의",
      type4: "채용 문의",
      type5: "기타",
      msg_label: "메시지 / Message *",
      msg_placeholder: "문의 내용을 입력해주세요",
      error: "전송 중 오류가 발생했습니다. 다시 시도해주세요.",
      submit: "문의 보내기",
      sending: "전송 중...",
      success_title: "문의가 접수되었습니다!",
      success_desc: "빠른 시일 내에 답변드리겠습니다.",
      retry: "다시 문의하기",
    },
    footer: {
      tagline: "AI를 통해 사람과 사람을 연결하는 기술.",
      momo_desc: "K-컬처 기반 소셜 교류 플랫폼 MOMO를 만들어갑니다.",
      tagline2: "Inspire · Know · Optimize · Build",
      company_name: "주식회사 아이콥 (IKOB Co., Ltd.)",
      ceo_prefix: "대표이사:",
      ceo_name: "오준호",
      address: "본사: 광주광역시 서구 양동로25번길 2, 2층 244호 | AI연구소: 서울특별시 강남구 강남대로112길 47, 2층 498A호",
      nav_company: "회사",
      nav_about: "회사소개",
      nav_team: "팀 소개",
      nav_tech: "핵심 기술",
      nav_recruit: "채용 문의",
      nav_services: "서비스",
      nav_momo: "MOMO 소개",
      nav_social: "사회적 가치",
      nav_invest: "투자 문의",
      nav_partner: "제휴 협력",
      copyright: "© 2026 IKOB Co., Ltd. All rights reserved.",
      sub_tagline: "AI를 통해 사람과 사람을 연결하는 기술",
    },
  };